(function () {
  function applyDiscount(root) {
    var input = root.querySelector('[data-nyron-discount-input]');
    if (!input) return;
    var code = (input.value || '').trim();
    if (!code) {
      input.focus();
      return;
    }
    var redirect = window.location.pathname.indexOf('/cart') === 0 ? '/cart' : '/cart';
    window.location.href =
      '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(redirect);
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest && event.target.closest('[data-nyron-discount-submit]');
    if (!button) return;
    event.preventDefault();
    var root = button.closest('[data-nyron-discount]');
    if (root) applyDiscount(root);
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Enter') return;
    var input = event.target.closest && event.target.closest('[data-nyron-discount-input]');
    if (!input) return;
    event.preventDefault();
    var root = input.closest('[data-nyron-discount]');
    if (root) applyDiscount(root);
  });
})();

/* ===== NYRON PDP interactions ===== */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initBa(root) {
    var clip = root.querySelector('[data-nyron-ba-clip]');
    var handle = root.querySelector('[data-nyron-ba-handle]');
    var range = root.querySelector('[data-nyron-ba-range]');
    var frame = root.querySelector('.NyronBa__Frame');
    if (!clip || !frame) return;
    function set(pct) {
      pct = Math.max(0, Math.min(100, pct));
      clip.style.width = pct + '%';
      if (handle) handle.style.left = pct + '%';
      if (range && range.value != pct) range.value = pct;
    }
    function fromEvent(e) {
      var point = e.touches && e.touches[0] ? e.touches[0] : e;
      var rect = frame.getBoundingClientRect();
      set(((point.clientX - rect.left) / rect.width) * 100);
    }
    var dragging = false;
    var knob = handle ? handle.querySelector('span') : null;
    frame.addEventListener('pointerdown', function (e) { fromEvent(e); });
    if (knob) {
      knob.addEventListener('pointerdown', function (e) {
        dragging = true;
        e.preventDefault();
        knob.setPointerCapture && knob.setPointerCapture(e.pointerId);
      });
      knob.addEventListener('pointermove', function (e) { if (dragging) { e.preventDefault(); fromEvent(e); } });
      ['pointerup', 'pointercancel'].forEach(function (t) {
        knob.addEventListener(t, function () { dragging = false; });
      });
    }
    window.addEventListener('pointermove', function (e) { if (dragging) fromEvent(e); }, { passive: true });
    window.addEventListener('pointerup', function () { dragging = false; });
    if (range) range.addEventListener('input', function () { set(parseFloat(range.value)); });
    var sizeSync = function () { root.style.setProperty('--nyron-ba-w', frame.getBoundingClientRect().width + 'px'); };
    sizeSync();
    window.addEventListener('resize', sizeSync);
    if (window.ResizeObserver) new ResizeObserver(sizeSync).observe(frame);
    set(50);
  }

  function init() {
    document.querySelectorAll('[data-nyron-ba]').forEach(initBa);

    var reveals = document.querySelectorAll('[data-nyron-reveal]');
    if (reduce || !('IntersectionObserver' in window)) {
      reveals.forEach(function (el) { el.classList.add('is-in'); });
    } else {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) { entry.target.classList.add('is-in'); io.unobserve(entry.target); }
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
      reveals.forEach(function (el) { io.observe(el); });
    }

    var scroll = document.querySelector('[data-nyron-scroll] .NyronScroll__Img');
    if (scroll && !reduce) {
      var ticking = false;
      window.addEventListener('scroll', function () {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(function () {
          var rect = scroll.parentNode.getBoundingClientRect();
          var progress = (window.innerHeight - rect.top) / (window.innerHeight + rect.height);
          scroll.style.transform = 'translate3d(0,' + (progress * -40).toFixed(2) + 'px,0) scale(1.12)';
          ticking = false;
        });
      }, { passive: true });
    }

    var sticky = document.querySelector('[data-nyron-sticky]');
    var mainForm = document.querySelector('.ProductForm__AddToCart');
    if (sticky) {
      var toggle = function () {
        var show = true;
        if (mainForm) {
          var r = mainForm.getBoundingClientRect();
          show = r.bottom < 0;
        }
        sticky.classList.toggle('is-visible', show);
      };
      window.addEventListener('scroll', toggle, { passive: true });
      window.addEventListener('resize', toggle);
      toggle();
      document.addEventListener('variant:changed', function (e) {
        var variant = e.detail && e.detail.variant;
        if (!variant) return;
        var id = sticky.querySelector('[data-nyron-sticky-id]');
        var btn = sticky.querySelector('[data-nyron-sticky-btn]');
        var price = sticky.querySelector('[data-nyron-sticky-price]');
        if (id) id.value = variant.id;
        if (btn) { btn.disabled = !variant.available; btn.textContent = variant.available ? 'In den Warenkorb' : 'Ausverkauft'; }
        if (price && window.Shopify && window.Shopify.formatMoney) price.textContent = window.Shopify.formatMoney(variant.price);
      });
    }

    document.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('[data-nyron-to-buy]');
      if (!a) return;
      e.preventDefault();
      var target = document.querySelector('.ProductForm__AddToCart') || document.querySelector('#shopify-section-main-product');
      if (target) target.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();

/* ================= NYRON Attribution & Pixel-Events ================= */
(function () {
  var KEYS = ['utm_source','utm_medium','utm_campaign','utm_content','utm_term','ttclid','fbclid'];
  var STORE = 'nyron-attribution';

  function capture() {
    try {
      var p = new URLSearchParams(location.search), found = {};
      KEYS.forEach(function (k) { var v = p.get(k); if (v) found[k] = v; });
      if (Object.keys(found).length) localStorage.setItem(STORE, JSON.stringify(found));
    } catch (e) {}
  }

  function stored() {
    try { return JSON.parse(localStorage.getItem(STORE) || '{}') || {}; } catch (e) { return {}; }
  }

  /** Hängt Attribution an alle Checkout-Links/-Formulare. */
  function decorate() {
    var data = stored();
    if (!Object.keys(data).length) return;
    document.querySelectorAll('form[action*="/cart"], form[action*="/checkout"]').forEach(function (form) {
      Object.keys(data).forEach(function (k) {
        if (form.querySelector('input[name="' + k + '"]')) return;
        var i = document.createElement('input');
        i.type = 'hidden'; i.name = k; i.value = data[k];
        form.appendChild(i);
      });
    });
  }

  function send(event, payload) {
    if (window.fbq) window.fbq('track', event, {
      content_type: 'product',
      content_ids: [payload.id],
      content_name: payload.name,
      value: payload.value,
      currency: payload.currency,
      num_items: payload.quantity
    });
    if (window.ttq && window.ttq.track) window.ttq.track(event, {
      content_id: payload.id,
      content_type: 'product',
      content_name: payload.name,
      quantity: payload.quantity,
      price: payload.price,
      value: payload.value,
      currency: payload.currency
    });
  }

  function productPayload() {
    var el = document.querySelector('[data-nyron-product]');
    if (!el) return null;
    var price = parseFloat(el.getAttribute('data-price') || '0');
    return {
      id: el.getAttribute('data-variant-id') || '',
      name: el.getAttribute('data-title') || '',
      price: price,
      quantity: 1,
      value: price,
      currency: el.getAttribute('data-currency') || (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'CHF'
    };
  }

  function init() {
    capture();
    decorate();

    var p = productPayload();
    if (p) send('ViewContent', p);

    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form || !form.action) return;
      if (form.action.indexOf('/cart/add') > -1) {
        var pay = productPayload();
        if (pay) send('AddToCart', pay);
      } else if (form.action.indexOf('/checkout') > -1 || form.querySelector('[name="checkout"]')) {
        var c = productPayload();
        if (c) send('InitiateCheckout', c);
      }
    }, true);

    document.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('[name="checkout"], [href*="/checkout"]');
      if (!b) return;
      var c = productPayload();
      if (c) send('InitiateCheckout', c);
    }, true);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
